var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"id":"path-1","points":"14 8.5 14 16.5 9.75 12.5397995"}));
}

ArrowLeft.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
